<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-10 10:01:48
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-10 10:01:48
 * @FilePath: \vue-privilege-routing\src\pages\resource\app-manage\index.vue
-->
<template>
    <div>
       app管理
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
